import "../../../styles/assets/images/icons/material/designSystem/Add.js";
import "../../../styles/assets/images/icons/material/designSystem/AddCircle.js";
import "../../../styles/assets/images/icons/material/designSystem/AddCircleFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/AdminPanelSettings.js";
import "../../../styles/assets/images/icons/material/designSystem/AdminPanelSettingsFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/Analytics.js";
import "../../../styles/assets/images/icons/material/designSystem/AnalyticsFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/Apartment.js";
import "../../../styles/assets/images/icons/material/designSystem/Apps.js";
import "../../../styles/assets/images/icons/material/designSystem/ArrowBack.js";
import "../../../styles/assets/images/icons/material/designSystem/ArrowDropDown.js";
import "../../../styles/assets/images/icons/material/designSystem/ArrowDropUp.js";
import "../../../styles/assets/images/icons/material/designSystem/ArrowForward.js";
import "../../../styles/assets/images/icons/material/designSystem/Bolt.js";
import "../../../styles/assets/images/icons/material/designSystem/BoltFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/BugReport.js";
import "../../../styles/assets/images/icons/material/designSystem/CalendarTodayFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/Cancel.js";
import "../../../styles/assets/images/icons/material/designSystem/CancelFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/CheckCircle.js";
import { ReactComponent as ForwardRef$3 } from "../../../styles/assets/images/icons/material/designSystem/CheckCircleFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/ChevronLeft.js";
import "../../../styles/assets/images/icons/material/designSystem/ChevronRight.js";
import "../../../styles/assets/images/icons/material/designSystem/Circle.js";
import "../../../styles/assets/images/icons/material/designSystem/CircleFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/Close.js";
import "../../../styles/assets/images/icons/material/designSystem/ConfirmationNumber.js";
import "../../../styles/assets/images/icons/material/designSystem/ConfirmationNumberFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/ContactSupport.js";
import "../../../styles/assets/images/icons/material/designSystem/ContactSupportFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/CreditCard.js";
import "../../../styles/assets/images/icons/material/designSystem/CreditCardFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/Dashboard.js";
import "../../../styles/assets/images/icons/material/designSystem/DashboardFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/Delete.js";
import "../../../styles/assets/images/icons/material/designSystem/DeleteFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/DirectionsCar.js";
import "../../../styles/assets/images/icons/material/designSystem/DirectionsCarFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/DirectionsFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/Edit.js";
import "../../../styles/assets/images/icons/material/designSystem/EditFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/ElectricCar.js";
import "../../../styles/assets/images/icons/material/designSystem/ElectricCarFilled.js";
import { ReactComponent as ForwardRef$1 } from "../../../styles/assets/images/icons/material/designSystem/Error.js";
import "../../../styles/assets/images/icons/material/designSystem/ErrorFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/EventFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/ExpandContent.js";
import "../../../styles/assets/images/icons/material/designSystem/ExpandLess.js";
import "../../../styles/assets/images/icons/material/designSystem/ExpandMore.js";
import "../../../styles/assets/images/icons/material/designSystem/Favorite.js";
import "../../../styles/assets/images/icons/material/designSystem/FavoriteFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/FirstPage.js";
import "../../../styles/assets/images/icons/material/designSystem/Forward.js";
import "../../../styles/assets/images/icons/material/designSystem/GarageHome.js";
import "../../../styles/assets/images/icons/material/designSystem/GarageHomeFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/Group.js";
import "../../../styles/assets/images/icons/material/designSystem/GroupFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/Home.js";
import "../../../styles/assets/images/icons/material/designSystem/HomeFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/Info.js";
import { ReactComponent as ForwardRef } from "../../../styles/assets/images/icons/material/designSystem/InfoFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowLeft.js";
import "../../../styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowRight.js";
import "../../../styles/assets/images/icons/material/designSystem/LastPage.js";
import "../../../styles/assets/images/icons/material/designSystem/ListAlt.js";
import "../../../styles/assets/images/icons/material/designSystem/ListAltFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/Logout.js";
import "../../../styles/assets/images/icons/material/designSystem/Mail.js";
import "../../../styles/assets/images/icons/material/designSystem/MailFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/Menu.js";
import "../../../styles/assets/images/icons/material/designSystem/MonitorHeart.js";
import "../../../styles/assets/images/icons/material/designSystem/MonitorHeartFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/MoreVert.js";
import "../../../styles/assets/images/icons/material/designSystem/Notifications.js";
import "../../../styles/assets/images/icons/material/designSystem/NotificationsFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/Pending.js";
import "../../../styles/assets/images/icons/material/designSystem/Person.js";
import "../../../styles/assets/images/icons/material/designSystem/PersonFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/PriceChange.js";
import "../../../styles/assets/images/icons/material/designSystem/PriceChangeFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/PushPin.js";
import "../../../styles/assets/images/icons/material/designSystem/PushPinFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/Refresh.js";
import "../../../styles/assets/images/icons/material/designSystem/Reply.js";
import "../../../styles/assets/images/icons/material/designSystem/Route.js";
import "../../../styles/assets/images/icons/material/designSystem/Schedule.js";
import "../../../styles/assets/images/icons/material/designSystem/Search.js";
import "../../../styles/assets/images/icons/material/designSystem/Settings.js";
import "../../../styles/assets/images/icons/material/designSystem/SettingsFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/Shield.js";
import "../../../styles/assets/images/icons/material/designSystem/ShieldFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/Smartphone.js";
import "../../../styles/assets/images/icons/material/designSystem/SmartphoneFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/Tune.js";
import "../../../styles/assets/images/icons/material/designSystem/VisibilityFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/VisibilityOffFilled.js";
import { ReactComponent as ForwardRef$2 } from "../../../styles/assets/images/icons/material/designSystem/Warning.js";
import "../../../styles/assets/images/icons/material/designSystem/WarningFilled.js";
import "../../../styles/assets/images/icons/material/designSystem/Work.js";
import "../../../styles/assets/images/icons/material/designSystem/WorkFilled.js";
import "../../../styles/assets/images/icons/brands/GoogleG.js";
import "react";
var FlashInfoMessageType = /* @__PURE__ */ ((FlashInfoMessageType2) => (FlashInfoMessageType2.critical = "critical", FlashInfoMessageType2.warning = "warning", FlashInfoMessageType2.success = "success", FlashInfoMessageType2.info = "info", FlashInfoMessageType2))(FlashInfoMessageType || {});
const INFO_MESSAGE_DEFAULTS = {
  info: {
    Icon: ForwardRef
  },
  critical: {
    Icon: ForwardRef$1
  },
  warning: {
    Icon: ForwardRef$2
  },
  success: {
    Icon: ForwardRef$3
  }
};
export {
  FlashInfoMessageType,
  INFO_MESSAGE_DEFAULTS
};
//# sourceMappingURL=constants.js.map
